import { useState } from "react";
import { Link } from "react-router-dom";

export function CookieBanner() {
  const [choice, setChoice] = useState(() => localStorage.getItem("pc-cookie-consent"));
  if (choice) return null;
  const save = (v) => { localStorage.setItem("pc-cookie-consent", v); setChoice(v); };
  return (
    <div role="dialog" aria-live="polite" aria-label="Preferenze cookie" data-testid="cookie-banner" className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-3xl rounded-2xl glass p-5 shadow-2xl sm:inset-x-6">
      <p className="text-sm leading-relaxed text-[var(--ghiaccio)]">
        Questo sito utilizza archiviazione locale e cookie tecnici necessari al funzionamento (preferenze di visualizzazione e accesso all'area riservata). Eventuali strumenti di terze parti vengono descritti nella{" "}
        <Link to="/cookie-policy" className="underline decoration-[var(--blu)] underline-offset-4" data-testid="cookie-banner-policy-link">cookie policy</Link>.
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button type="button" className="btn btn-blue btn-sm" onClick={() => save("all")} data-testid="cookie-accept-btn">Accetta</button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => save("necessary")} data-testid="cookie-necessary-btn">Solo necessari</button>
      </div>
    </div>
  );
}
